import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { imageSrc } from 'apps/file/utils';
import { Follow } from 'apps/content/views/follow';
import { conf as mainConf } from 'apps/config.yaml';
import {
  ProfileWrapper,
  ProfileAvatar,
  Title,
  Bio,
  FollowButtonWrapper,
} from 'apps/modals/connResultsModal/styles';

@observer
export class ProfileListItem extends React.Component {
  clickUser = () => {
    modalStore.ClearComponent();
    clientStore.routerStore.navigate('profile', {
      profile: this.props.profile.username,
    });
  };

  render() {
    const { profile } = this.props;
    const { id, avatar, fullName, bio } = profile;
    return (
      <>
        <ProfileWrapper key={id}>
          <ProfileAvatar
            onClick={this.clickUser}
            src={imageSrc(
              avatar,
              profile.imageFallbackPath,
              mainConf.imgSizes.profile.large,
            )}
          />
          <Title onClick={this.clickUser}>{fullName}</Title>
          <Bio>{bio}</Bio>
          {profile.username === clientStore.signedInProfile.username ? (
            <React.Fragment />
          ) : (
            <FollowButtonWrapper>
              <Follow content={profile.content} small />
            </FollowButtonWrapper>
          )}
        </ProfileWrapper>
      </>
    );
  }
}

ProfileListItem.propTypes = {
  profile: PropTypes.object,
};
